import React from "react";

class HandyScroll extends React.Component {
  componentDidMount() {
    /* eslint-disable */
    if (handyScroll && this.el.firstElementChild) {
      handyScroll.mount(this.el.firstElementChild);
    }

    /* eslint-enable */
  }

  componentWillUnmount() {
    /* eslint-disable */
    //    handyScroll.destroy(this.el.firstElementChild);
    /* eslint-enable */
  }

  componentDidUpdate() {
    /* eslint-disable */
    if (handyScroll.mounted(".spacious-container")) {
      handyScroll.update(".spacious-container");
    }
    /* eslint-enable */
  }

  render() {
    return <div ref={(el) => (this.el = el)}>{this.props.children}</div>;
  }
}
export default HandyScroll;
